import type { MouseEvent, ReactNode } from 'react'
import { useBlockDraftContext } from './BlockDraftContext'

// Клики по управлению (кнопки, поля, меню) выделение не трогают — только пустое место.
const INTERACTIVE = 'button, a, input, textarea, select, [contenteditable="true"], [role="dialog"]'

/**
 * Холст редактора: клик по пустому месту — по экрану урока вне элементов или по
 * тёмному фону вокруг телефона — снимает выделение элемента составного блока.
 * Сами элементы глушат всплытие (`SortableDesignElement`), поэтому сюда доходят
 * только клики мимо них.
 */
export const DeselectOnEmptyClick = ({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) => {
  const { selectedElementId, setSelectedElementId } = useBlockDraftContext()
  const onClick = (e: MouseEvent) => {
    if (selectedElementId === null) return
    if ((e.target as Element).closest(INTERACTIVE)) return
    setSelectedElementId(null)
  }
  return (
    <div className={className} onClick={onClick}>
      {children}
    </div>
  )
}
